import { useQuery } from "@tanstack/react-query";
import { fetchDashboardCategories } from "../services/categoriesService";

export function useDashboardCategories(params = {}, options = {}) {
  return useQuery({
    queryKey: ["dashboardCategories", params],
    queryFn: async () => {
      const { payload } = await fetchDashboardCategories(params);

      return {
        stateName: payload?.state_name || "",
        categories: Array.isArray(payload?.categories_list)
          ? payload.categories_list
          : Array.isArray(payload?.category_list)
            ? payload.category_list
            : Array.isArray(payload?.categories)
              ? payload.categories
              : [],
        quizCategories: Array.isArray(payload?.quiz_categories) ? payload.quiz_categories : [],
        advertEarnedCoins: Number(payload?.advert_earned_coins || 0),
        userLang: payload?.user_lang || "",
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        stateName: "",
        categories: [],
        quizCategories: [],
        advertEarnedCoins: 0,
        userLang: "",
      },
  });
}
